<ion-content>
  <div class="main">
    <img class="logo" src="assets/images/logo.jpg" />
    <p class="center">
      Link expirado ou inválido.
    </p>
  </div>
</ion-content>
